/**
 * Escala del eje vertical de un grafico: marcas en numeros redondos (1, 2 o 5
 * por potencia de diez) que cubren el maximo. Asi el eje dice "$50 mil" y no
 * "$47.312", y se adapta solo a lo que se vendio.
 */

/** Tramos en que se divide el eje, aproximado: el paso redondo manda. */
const TRAMOS = 4;

/** Tope minimo, para que un periodo sin ventas no dibuje un eje de $0 a $1. */
const TOPE_MINIMO = 1000;

function pasoRedondo(aproximado: number): number {
  const potencia = 10 ** Math.floor(Math.log10(aproximado));
  const fraccion = aproximado / potencia;
  if (fraccion <= 1) return potencia;
  if (fraccion <= 2) return 2 * potencia;
  if (fraccion <= 5) return 5 * potencia;
  return 10 * potencia;
}

export interface EscalaGrafico {
  /** Valor de la linea mas alta; la barra que lo alcance llena el grafico. */
  tope: number;
  /** Marcas del eje, de 0 al tope. */
  marcas: number[];
}

export function escalaGrafico(valores: number[]): EscalaGrafico {
  const maximo = Math.max(...valores, TOPE_MINIMO);
  const paso = pasoRedondo(maximo / TRAMOS);
  const tope = Math.ceil(maximo / paso) * paso;
  const marcas = Array.from({ length: Math.round(tope / paso) + 1 }, (_, indice) => indice * paso);
  return { tope, marcas };
}
